import { useLayoutEffect, useRef, useState } from "react";

// Diagnosa / Rencana Tindakan in the Antrian list: each line at most two lines, cut with "…". The full text is in the
// hover tooltip and shows when `expanded`; one "Lihat selengkapnya" for the whole group appears only when some text is
// really cut. `prefix` ("Dx", "Tx") labels a line where there is no column header (compact table, phone cards).
// Empty text is a dimmed "-".
export default function ClampedText({ lines, expanded, onToggle, toggleTestId, className = "" }) {
  const refs = useRef([]);
  const [cut, setCut] = useState(false);
  const texts = lines.map((l) => (l.text || "").trim());

  useLayoutEffect(() => {
    if (expanded) return undefined;       // keep the last measurement while expanded, so the toggle stays
    const els = refs.current.filter(Boolean);
    const check = () => setCut(els.some((el) => el.scrollHeight > el.clientHeight + 1));
    check();
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(check);
    els.forEach((el) => ro.observe(el));
    return () => ro.disconnect();
  }, [texts.join("\u0000"), expanded]);   // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`min-w-0 space-y-0.5 ${className}`}>
      {lines.map((l, i) => {
        const label = l.prefix && <span className="font-semibold text-slate-500">{l.prefix}: </span>;
        if (!texts[i]) {
          refs.current[i] = null;
          return <p key={l.title} className="text-xs leading-snug text-slate-400" data-testid={l.testId}>{label}-</p>;
        }
        return (
          <p key={l.title} ref={(el) => { refs.current[i] = el; }} title={`${l.title}: ${texts[i]}`}
            onClick={cut ? onToggle : undefined}
            className={`text-xs leading-snug text-slate-600 break-words whitespace-pre-line ${expanded ? "" : "line-clamp-2"} ${cut ? "cursor-pointer" : ""}`}
            data-testid={l.testId}>
            {label}{texts[i]}
          </p>
        );
      })}
      {cut && (
        <button type="button" onClick={onToggle} aria-expanded={Boolean(expanded)}
          className="py-0.5 text-[11px] font-medium text-[#267B84] underline underline-offset-2 hover:text-[#1e5f66]"
          data-testid={toggleTestId}>
          {expanded ? "Sembunyikan" : "Lihat selengkapnya"}
        </button>
      )}
    </div>
  );
}
